import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tab_edge",
  "use": "tab_edge-usage",
  "viewBox": "0 0 30 54",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 54\" id=\"tab_edge\">\r\n    <path class=\"cls-1\" d=\"M1.15,0H0V54H30L3.83,1.66A3,3,0,0,0,1.15,0Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol